import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CreateForecastButton } from './CreateForecastButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { setHasPortalSeenFmoAdminOnboarding } from '../../actions/PortalSettingsActions';
import { CLICK_CREATE_FORECAST_WELCOME_MODAL, CLICK_USE_DEFAULT_WELCOME_MODAL } from '../../constants/Events';
import useOverviewModal from '../../hooks/useOverviewModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActivationPortalModal = ({
  onCloseFunction
}) => {
  const [isOpen, handleClose] = useOverviewModal(setHasPortalSeenFmoAdminOnboarding());
  const handleClickUseDefalutColumnButton = useCallback(() => {
    handleClose(CLICK_USE_DEFAULT_WELCOME_MODAL);
    if (onCloseFunction) {
      onCloseFunction();
    }
  }, [handleClose, onCloseFunction]);
  const handleClickCreateForecastButton = useCallback(() => handleClose(CLICK_CREATE_FORECAST_WELCOME_MODAL), [handleClose]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 740,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.existing.portalActivationModal.modalHeader"
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "700",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flex: 1,
          borderWidth: "100",
          borderColor: "border-core-subtle",
          borderRadius: "100",
          borderStyle: "solid",
          padding: "400",
          flexDirection: "column",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "800",
            children: [/*#__PURE__*/_jsx(Illustration, {
              name: "forecasting",
              height: 70
            }), /*#__PURE__*/_jsx(Text, {
              as: "h4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "tour.existing.portalActivationModal.defaultColumnHeader"
              })
            }), /*#__PURE__*/_jsx(Flex, {
              alignItems: "start",
              children: /*#__PURE__*/_jsxs(List, {
                styled: true,
                children: [/*#__PURE__*/_jsx(ListItem, {
                  children: /*#__PURE__*/_jsx(Text, {
                    textAlign: "start",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "tour.existing.portalActivationModal.defaultColumnBody"
                    })
                  })
                }), /*#__PURE__*/_jsx(ListItem, {
                  children: /*#__PURE__*/_jsx(Text, {
                    textAlign: "start",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "tour.existing.portalActivationModal.defaultColumnBody2"
                    })
                  })
                })]
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            children: /*#__PURE__*/_jsx(UIButton, {
              className: "m-top-4",
              onClick: handleClickUseDefalutColumnButton,
              use: "primary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "tour.existing.portalActivationModal.defaultColumnAction"
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flex: 1,
          borderWidth: "100",
          borderColor: "border-core-subtle",
          borderRadius: "100",
          borderStyle: "solid",
          padding: "400",
          flexDirection: "column",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "800",
            children: [/*#__PURE__*/_jsx(Illustration, {
              name: "plus",
              height: 70
            }), /*#__PURE__*/_jsx(Text, {
              as: "h4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "tour.existing.portalActivationModal.createNewHeader"
              })
            }), /*#__PURE__*/_jsxs(List, {
              styled: true,
              children: [/*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(Text, {
                  textAlign: "start",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "tour.existing.portalActivationModal.createNewBody"
                  })
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(Text, {
                  textAlign: "start",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "tour.existing.portalActivationModal.createNewBody2"
                  })
                })
              })]
            })]
          }), /*#__PURE__*/_jsx(View, {
            children: /*#__PURE__*/_jsx(CreateForecastButton, {
              buttonLocation: "modal",
              buttonSize: "medium",
              buttonTextOverride: "tour.existing.portalActivationModal.createNewAction",
              marginBlockStart: "400",
              onButtonClick: handleClickCreateForecastButton
            })
          })]
        })]
      })
    })]
  });
};